export default __webpack_public_path__ + "static/karticky-13b882083c87d763cf14a4351d2204bc.png";